import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { AnimateModule, BasicPage } from '@pro-connect/shared';
import { CityComponent } from '../../components/pillar/city.component';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@Component({
  templateUrl: './madrid.component.html',
  styleUrls: ['./madrid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AnimateModule, CityComponent],
})
export class MadridComponent extends BasicPage {
  public override readonly loading = signal(false);
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  public readonly plan: { title: string; list: string[] }[] = [
    {
      title: 'DZIEŃ I - RUSZAMY NA PODBÓJ MADRYTU!',
      list: [
        'Popołudniowy przylot do Madrytu',
        'Bar&Tapas food tour',
        'Noc na mieście – po kolacji kontynuacja zabawy w jednym z licznych klubów',
      ],
    },
    {
      title: 'DZIEŃ II - MADRYT WYZNACZA TRENDY',
      list: [
        'Wizyta w Akademii L’Oréal',
        'M.in. showroom konceptualizujący Salon Przyszłości',
        'Tour po Madrycie na rowerach elektrycznych',
        'Wieczór w dzielnicy Malsana – tętniącej życiem okolicy pełnej barów i różnych lokali',
      ],
    },
    {
      title: 'DZIEŃ III - MIASTO SZTUKI',
      list: [
        'Prywatne zwiedzanie Muzeum Prado lub Muzeum Reina Sofia',
        'Wizyty w salonach fryzjerskich',
        'Koktajl na rooftop barze Bellas Artes',
        'Kolacja i dalsza część zabawy na mieście',
      ],
    },
    {
      title: 'DZIEŃ IV - JAK SMAKUJE MADRYT?',
      list: [
        'Poranny tour fryzjerski – wizyta w salonie',
        'Mercado San Miguel – wizyta i degustacje lunchowe',
        'Popołudniowy przejazd na lotnisko i wylot do Polski',
      ],
    },
  ];

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this._pushLayer();
  }

  private _pushLayer(): void {
    this._angulartics2GoogleTagManager.pushLayer({
      brand: 'LDB',
      language: 'pl',
      country: 'Pl',
      siteTypeLevel: this._isDevelopment ? 'test' : 'main',
      pageCategory: 'trip',
      geoIPLocation: 'Pl',
      uiLoggedStatus: !!this.user() ? 'logged' : 'not logged',
      uiType: this.user()?.type,
    });
  }
}
